import { SvgSuccess } from "../../../assets/icons/SvgSuccess";
import { Button } from "../Button/Button";
import { useGlobalModalContext } from "./GlobalModal";

export const SuccessModal = () => {
  const { hideModal, store } = useGlobalModalContext();
  const { modalProps } = store;
  const { title, subTitle } = modalProps;

  const handleModalToggle = () => {
    hideModal();
  };

  return (
    <div className="min-w-[325px] p-[25px] text-center rounded bg-white">
      <div className="mb-[25px] flex justify-center ">
        <SvgSuccess className="h-[50px] w-[50px]" />
      </div>
      <p className="m-auto mb-[25px] w-[80%] text-base font-semibold">
        {title}
      </p>
      {subTitle && (
        <p className="m-auto mb-[25px] w-[80%] text-sm font-semibold text-lightGray">
          {subTitle}
        </p>
      )}
      <Button
        className="m-auto block text-base font-medium tracking-wider"
        onClick={handleModalToggle}
      >
        Продолжить
      </Button>
    </div>
  );
};
